var xmega = function () { };

xmega.prototype = {
	init: function (el) {
		var me = this;
		me.el = el;
		me.render(el);

		el[0].xmega = me;

		me.ajax = Object.create(me._ajax).init(me);
		me.listeners();
		//me.ajax.init(me);
		return me;
	},
	render: function (el) {
		var me = this;
		me.el = el;
		me.clearvalue = el.find('.btn-clearvalue');
		me.details = el.find('.fieldText');
		me.xinput = el.find('input.mainText');
		me.xtext = el.find('span.fieldText');
		me.xtextVal = me.xinput.val();
		me.contentBox = el.find('.contentBox');
		me.contentBoxList = me.contentBox.first();
		me.contentBoxComp = me.contentBox.last();
		me.document = $(document);
		me.dataset = el.find('.input-group').data('dataset');
		me.where = el.find('.form-group').data('where');

		me.stateVal = me.xinput.val();

		// Define custom where
		if (me.el.data('customwhere')) {
			me.customWhere = me.el.data('customwhere');
		}

		// Controllinimas kitos xmegos
		if (el.data('control') && el.data('control').length > 0) {
			me.controlInput = el.data('control');
			me.controlKey = el.data('controlkey');
			me.controlMega = $(`.xmega[data-listen=${el.data('controlkey')}]`);
		} else if (el.data('listen')) {
			me.listenMega = $(`.xmega[data-controlkey=${el.data('listen')}]`);
			me.listenKey = me.listenMega.data('controlkey');
		}

		el.addClass('rendered');

	},
	listeners: function (el) {
		var me = this;

		me.details.on('click', function (e) {
			e.stopPropagation();
			me.clearBoxes();
			me.ajax.detail();

			me.contentBoxComp.on('click', function (e) {
				e.stopPropagation();
			});

			$(document).one('click', function (e) {
				me.contentBoxComp.removeClass('active');
				me.contentBoxComp.hide();
			});
		});

		// Clear Button Events --------------------------------
		me.clearvalue.on('click', function (e) {
			e.stopPropagation();
			me.el.click();
			$(this).toggleClass('d-none', true);

			if (me.controlMega) {
				me.clearValues();
			}

			// Valom values
			me.xinput.val('');
			me.xtext.text('');
			me.stateVal = '';
		});

		me.el.find('.form-control').on('mouseover', function (e) {
			if (me.details.text()) {
				me.clearvalue.toggleClass('d-none', false);
			}
		});

		me.el.find('.form-control').on('mouseout', function (e) {
			if (me.details.text()) {
				me.clearvalue.toggleClass('d-none', true);
			}
		});
		// --------------------------------------------------------

		// On xmega click
		me.el.on('click', function (e) {
			e.stopPropagation();
			me.clearBoxes();

			me.contentBoxComp.hide();
			me.contentBoxComp.removeClass('active');
			me.details.hide();

			me.contentBoxList.addClass('active');

			//var reloadTable = false;
			//Jei pasikeite where salyga atnaujinam duomenis (chaltura nes du kartus sauna ajax open)
			if (me.el.find('.form-group').data('where') != me.where) {
				me.where = me.el.find('.form-group').data('where');
				//reloadTable = true;
			}
			var checkIfRendered = me.contentBoxList.hasClass('rendered');
			if (checkIfRendered === true) {

				me.contentBoxList.show();
				me.xinput.val(null);
				me.xinput.show().focus();

				$(document).one('click', function (e) {
					me.contentBoxList.removeClass('active');
					me.contentBoxList.hide();

					me.xinput.val(me.stateVal);

					if (me.xtext.text().length === 0) {
						me.xinput.val('');
					}

					if (typeof me.onClose === 'function') {
						me.onClose();
					}

					me.xinput.hide();
					me.details.show();
				});

				// Close Button
				me.contentBoxList.find('.header').find('.btn-close i').on('click', function (e) {
					e.stopPropagation();

					if (typeof me.onClose === 'function') {
						me.onClose();
					}

					me.contentBoxList.removeClass('active');
					me.contentBoxList.hide();
					me.details.show();
					me.xinput.hide();
				});
				//if(reloadTable){ //atnaujinam lentele
				//	me.ajax.open(false, oldValue);
				//}
				//return;
			}

			me.contentBoxComp.add(me.details).removeClass('active').hide();
			me.xinput.val(null);
			$(document).one('click', function (e) {
				me.contentBoxList.removeClass('active');
				me.contentBoxList.hide();
				if (!me.xinput.val()) {
					me.xinput.val(me.stateVal);
				}

				if (typeof me.onClose === 'function') {
					me.onClose();
				}

				me.xinput.hide();
				me.details.show();
			});

			// Change to ajax function!!
			me.ajax.open(false);
		});

		// On keyup input 'Search'
		me.xinput.on('keyup', function (e) {
			if (!$(this).val()) {
				me.ajax.open();
				return;
			}

			me.ajax.search($(this).val());
		});

		// On data click
		me.contentBoxList.on('click', 'ul li', function (e) {
			e.stopPropagation();
			let data = $(this).data(),
				id = data.id,
				name = data.name;

			if (!id) {
				throw "XMEGA - nenurodytas ID";
			}
			me.contentBoxList.removeClass('active');
			me.contentBoxList.hide();

			me.xinput.val(id);

			// State val
			me.stateVal = id;

			me.xtext.html(name);
			me.xinput.hide();
			me.details.show();

			if (me.controlMega) {
				me.clearValues();
			}

			if (typeof me.onSelect === 'function') {
				me.onSelect();
			}
		});

		me.contentBoxList.on('click', '.header', function (e) {
			e.stopPropagation();
			me.xinput.focus();
		});
	},
	clearBoxes: function () {
		var me = this;
		$('.contentBox.active').hide();
		me.details.show();
	},
	clearValues: function () {
		var me = this;
		me.controlMega.find('.fieldText').text('');
		me.controlMega.find(`input[name=${me.controlInput}]`).val('');
	},
	preload: function (el) {
		let element = el[0],
			me = this;
		if (element.scrollTop + element.clientHeight >= element.scrollHeight - 100) {
			me.ajax.preload();
		}
	},
	_ajax: {
		init: function (me) {
			var ajax = this;
			ajax.parent = me;
			//console.log(web.zone);
			//debugger;
			ajax.config = {
				url: web.zone + '/xmega/list/' + me.dataset,
				type: 'POST',
				data: {},
				dataType: 'html',
				success: function (response) {
					ajax.callback(response);
				},

			};
			return ajax;
		},
		load: function () {
			this.loading = true;
			$.ajax(this.config);
		},
		open: function (checkIfRendered) {

			var ajax = this,
				me = ajax.parent;

			console.log(me.customWhere);

			ajax.config.data = {
				where: me.customWhere
			};

			// Listeninimo logika
			if (me.listenMega) {
				let listenValue = me.listenMega.find(`input[name=${me.listenKey}]`).val();
				ajax.config.url = web.zone + `/xmega/list/${me.dataset}/${listenValue}`;
			} else {
				ajax.config.url = web.zone + '/xmega/list/' + me.dataset;
			}

			ajax.callback = function (response) {
				me.contentBoxList.add(me.xinput).addClass('active').show().focus();
				me.contentBoxList.addClass('rendered');

				if (!checkIfRendered) {
					me.contentBoxList.html(response);
				} else {
					$(me.contentBoxList).find('tbody').html(response);
				}

				// Close Button
				me.contentBoxList.find('.header').find('.btn-close i').on('click', function (e) {
					e.stopPropagation();

					if (typeof me.onClose === 'function') {
						me.onClose();
					}

					me.xinput.val(me.stateVal);
					me.contentBoxList.removeClass('active');
					me.contentBoxList.hide();
					me.details.show();
					me.xinput.hide();
				});

				if (me.el.data('preload') == true) {
					me.contentBoxList.find('.content').on('scroll', function (e) {
						me.preload($(this));
					});
				}

				xlisteners.init();
			};
			ajax.load();
		},
		detail: function () {
			var ajax = this,
				me = ajax.parent;

			ajax.config.url = web.zone + '/xmega/detail/' + me.dataset + '/' + me.xinput.val();

			ajax.callback = function (response) {
				me.contentBoxComp.html(response);
				me.contentBoxComp.addClass('active').fadeIn('fast');

				me.contentBoxComp.find('.header').find('.btn-close i').on('click', function (e) {
					me.contentBoxComp.removeClass('active');
					me.contentBoxComp.hide();
				});
			};
			ajax.load();
		},
		preload: function () {
			var ajax = this,
				me = ajax.parent;

			ajax.config.url = web.zone + `/xmega/preload/${me.dataset}/`;

			ajax.callback = function (response) {
				me.contentBoxList.find('.content ul').append(response);
			};
			//ajax.load
			ajax.load();
		},
		search: function (term) {
			var ajax = this,
				me = ajax.parent;

			// Listeninimo logika
			if (me.listenMega) {
				let listenValue = me.listenMega.find(`input[name=${me.listenKey}]`).val();
				ajax.config.url = web.zone + `/xmega/search/${me.dataset}/${term}/${listenValue}`;
			} else {
				ajax.config.url = web.zone + `/xmega/search/${me.dataset}/${term}`;
			}

			ajax.callback = function (response) {
				me.contentBoxList.html(response);

				// Close button
				me.contentBoxList.find('.header').find('.btn-close i').on('click', function (e) {
					e.stopPropagation();

					if (typeof me.onClose === 'function') {
						me.onClose();
					}

					me.contentBoxList.removeClass('active');
					me.contentBoxList.hide();
					me.details.show();
					me.xinput.hide();
				});
			};
			//ajax.load
			ajax.load();
		},
		sort: function (data) {
			var ajax = this,
				me = ajax.parent;

			ajax.config.data.type = 'sort';

			ajax.callback = function (response) {
				$(me.contentBoxList).find('tbody').html(response);
				data.filterVal == "ASC" ? $(data.clickedRow).find('i').removeClass('fa fa-angle-up').addClass('fa fa-angle-down') : $(data.clickedRow).find('i').removeClass('fa fa-angle-down').addClass('fa fa-angle-up');
			};

			ajax.load();
		}
	}
};

(function ($) {
	$.fn.xmega = function (options) {
		var $xmega = this,
			xmegaEl;

		if ($xmega.length === 0) {
			throw new Error(
				'ERROR'
			);
		}

		if ($xmega[0].xmega) {
			return $xmega[0].xmega;
		}

		xmegaEl = new xmega().init($xmega);
		return xmegaEl;
	};
})(jQuery);